import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
// import { AuthService } from '../services/auth-service.service';
import { OAuthService } from '../services/oauth.service';
import { LoggerService } from '../services/logger.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private authService: OAuthService,
    private router: Router,
    private logger: LoggerService
  ) {}
  canLoad(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.checkLogin(route.path||"");
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return this.checkLogin(state.url)


    }
  async checkLogin(url: string): Promise<boolean> {
    if (await this.authService.isAuthenticated()) {
      return true;
    }

    // A stored but expired session may still be renewed by the startup refresh. Wait for
    // it instead of racing it with a full redirect to /connect/authorize.
    await this.authService.whenStartupSessionChecked();
    if (await this.authService.isAuthenticated()) {
      return true;
    }

    this.logger.debug('AuthGuard', 'Unauthenticated — saving redirect', url);
    this.authService.redirectUrl = url;
    this.authService.login();
    return false;
  }

}
